










































import {Component, Vue} from 'vue-property-decorator';
import Axios from "axios";
import Session from "@/App/controller/account/session";
import SessionData from "@/App/model/account/SessionData";
import Url from "@/App/controller/net/url";
import AdmincpMenu from "@/App/component/admincp-menu.vue";
import {TITLE_DEFAULT} from "@/App/data/define";

@Component({
    components: {AdmincpMenu}
})
export default class AdmincpPageEditPage extends Vue {
    public readonly name: string = 'admincp-page-edit'
    public Editor: any = undefined
    private HasDataSend: boolean = false
    private HasDataLoading: boolean = true
    private FormValues: {
        id: number
        title: string,
    } = {
        id: Number(this.$root.$route.params.id_page),
        title: ''
    }

    private mounted(): void {
        document.title = "Правка страницы - " + TITLE_DEFAULT
        if (isNaN(this.FormValues.id) === true) {
            Url.SetUrl('/admincp/page/')
            return
        }

        //@ts-ignore
        this.Editor = new Quill('#editor', {
            modules: {
                syntax: true
            },
            theme: 'snow'
        });
        this.DoLoadData()
    }

    private DoLoadData() {
        this.HasDataLoading = true
        Axios.post('//kosiaks.alkad.org/api/index.php', {
            method: 'page.item',
            //@ts-ignore
            session: Session.CurrentSession.SessionID,
            id_page: this.FormValues.id
        }).then(res => {
            if (res.data.code === 0) {
                this.Editor.root.innerHTML = res.data.result.full
                this.FormValues.title = res.data.result.title
            } else {
                Url.SetUrl('/admincp/page/')
            }
        }).finally(() => {
            this.HasDataLoading = false
        })
    }

    private OnSubmit(): void {
        this.HasDataSend = true
        Axios.post('//kosiaks.alkad.org/api/index.php', {
            method: 'page.edit',
            //@ts-ignore
            session: Session.CurrentSession.SessionID,
            id_page: this.FormValues.id,
            title: this.FormValues.title,
            text: this.Editor.root.innerHTML
        }).then(res => {

        }).finally(() => {
            this.HasDataSend = false
            Url.SetUrl('/admincp/page/')
        })
    }
}
